import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react'
import type { SortConfig } from '../hooks/useSortableData'

interface SortableThProps {
  label: string
  sortKey: string
  sortConfig: SortConfig | null
  onSort: (key: string) => void
  align?: 'left' | 'right'
}

/** Drop-in replacement for a plain <th> on columns that should be sortable.
 * Same base classes every <th> in this app already uses -- only "Acciones"
 * (or any action-only column) should stay a plain <th>, not this. */
export default function SortableTh({ label, sortKey, sortConfig, onSort, align = 'left' }: SortableThProps) {
  const isActive = sortConfig?.key === sortKey
  const Icon = isActive ? (sortConfig!.direction === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown

  return (
    <th className={`px-4 py-3 text-${align} text-xs font-medium text-espresso-500 uppercase tracking-wider`}>
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        className={`flex items-center gap-1 hover:text-espresso-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500 rounded ${
          align === 'right' ? 'ml-auto flex-row-reverse' : ''
        }`}
      >
        {label}
        <Icon className={`h-3 w-3 ${isActive ? 'text-terracotta-600' : 'text-espresso-300'}`} />
      </button>
    </th>
  )
}
